import React, { useEffect, useRef } from 'react';
import './WhyRenuit.css';

const DIFFERENTIATORS = [
  {
    title: 'Owned Warehouse Infrastructure',
    body: "Unlike pure freight brokers, we operate our own climate-controlled facilities in the Tampa Bay area. Your cargo never sits in a third-party facility we can't control.",
  },
  {
    title: 'Dedicated Account Manager',
    body: 'You get one named contact who knows your account, your lanes, and your preferences. No call centers. No re-explaining your situation every time.',
  },
  {
    title: 'Real-Time Shipment Visibility',
    body: 'Every active shipment is tracked and updated proactively. You receive milestone notifications without having to ask - and we call you before a delay affects your customer.',
  },
  {
    title: 'No Hidden Surcharges',
    body: 'Fuel surcharges, accessorial fees, and residential delivery costs are itemized upfront in every quote. The number we give you is the number on your invoice.',
  },
  {
    title: '48-Hour Quote Turnaround',
    body: "Standard freight quotes are returned within 24 hours. Complex custom plans within 48. You'll never wait three days to find out if we can serve your lane.",
  },
  {
    title: 'Licensed, Bonded & Insured',
    body: 'Fully compliant with FMCSA requirements. Carrier liability and cargo insurance documentation available on request. Your freight is protected end to end.',
  },
];

export const WhyRenuit = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const targets = sectionRef.current?.querySelectorAll<HTMLElement>('.rn-reveal');
    if (!targets) return;
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      }),
      { threshold: 0.07 }
    );
    targets.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="rn-why" ref={sectionRef}>
      <div className="rn-why__inner">

        <div className="rn-why__header rn-reveal">
          <span className="cs-topper">Why Renuit</span>
          <h2 className="rn-why__heading">Built Different From Day One</h2>
          <p className="rn-why__sub">
            Most logistics providers are brokers with a website. We’re an operator —
            with infrastructure, people, and accountability behind every shipment.
          </p>
        </div>

        <ul className="rn-why__list">
          {DIFFERENTIATORS.map(({ title, body }, i) => (
            <li key={title} className="rn-why__row rn-reveal">
              <span className="rn-why__num">0{i + 1}</span>
              <h3 className="rn-why__row-title">{title}</h3>
              <p className="rn-why__row-body">{body}</p>
            </li>
          ))}
        </ul>

      </div>
    </section>
  );
};
